<template>
    <div style="margin: 16px;">
      <el-card
        v-loading="pageLoading"
        shadow="hover"
        class="box-card"
        body-style="padding: 16px; padding-top: 8px;"
      >
        <el-table
          :height="windowHeight - 175"
          :data="updates"
          @row-click="showUpdate"
        >
          <el-table-column
            :fixed="$mq === 'xs' ? false : 'left'"
            label="Update"
            prop="update_title"
            min-width="150"
          >
            <template slot-scope="scope">
              <span
                style="display: block;"
                class="list-title"
              >
                {{ scope.row.update_title }}
              </span>
              <span
                class="list-subtext"
                style="display: block; margin-right: auto;"
              >
                {{ getFullName(scope.row.user) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="Submitter"
            prop="submitter"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ getFullName(scope.row.submitter) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Submitted"
            prop="created_at"
            align="center"
            min-width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.created_at != null ? scope.row.created_at.split(' ')[0] : ' ' }}
              <br>
              {{ scope.row.created_at != null ? scope.row.created_at.split(' ')[1] : ' ' }}
            </template>
          </el-table-column>
          <el-table-column
            label="Updated"
            prop="updated_at"
            align="center"
            min-width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.updated_at != null ? scope.row.updated_at.split(' ')[0] : ' ' }}
              <br>
              {{ scope.row.updated_at != null ? scope.row.updated_at.split(' ')[1] : ' ' }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="Recipients"
            prop="destination"
            width="120"
          >
            <template slot-scope="scope">
              <span v-if="distributionList != null">
                <span v-if="scope.row.destination.length > 1">
                  <span
                    v-for="d in scope.row.destination"
                    :key="d"
                    style="display: block;"
                  >
                    {{ distributionList.find(o => o.o_id == d).name }}
                  </span>
                </span>
                <span v-else>
                  {{ distributionList.find(o => o.o_id == scope.row.destination[0]).name }}
                </span>
              </span>
              <span v-else>
                <span v-loading="true" />
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :fixed="$mq === 'xs' ? false : 'right'"
            align="center"
            label="Actions"
            min-width="140"
          >
            <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.published"
                  type="success"
                  size="small"
                  icon="el-icon-check"
                  @click.stop="publishUpdate(scope.row)"
                />
                <el-button
                  v-if="scope.row.published"
                  type="warning"
                  size="small"
                  icon="el-icon-minus"
                  @click.stop="unpublishUpdate(scope.row)"
                />
            </template>
          </el-table-column>
        </el-table> 
        <el-pagination
          style="line-height: 12px; margin-top: 16px;"
          background
          layout="prev, pager, next"
          :page-count="lastPage"
          @current-change="changePage"
          :current-page="page"
          @prev-click="changePage"
          @next-click="changePage"
        />
      </el-card>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
    props: ['selectedUpdate'],
    mounted() {
        if(this.selectedTerms != null){
            this.getAdminUpdates();
        }
        if(this.distributionList == null)
            this.$store.dispatch('pullDistributionList');
    },
    computed: {
        ...mapFields([
            'user',
            'distributionList',
            'selectedTerms'
        ])
    },
    data() {
        return {
            updates: null,
            page: 1,
            lastPage: 1,
            pageLoading: true
        };
    },
    created() {
        if(!this.$store.getters.hasPermission(['All', 'Updates', 'Updates-Publish']))
            this.$router.push('/admin');
    },
    watch: {
        selectedTerms(){
            this.page = 1;
            this.getAdminUpdates();
        }
    },
    methods: {
        unpublishUpdate(update){
            this.axios.put('/api/v1/updates/unpublish/'+update.o_id, {},
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                this.updates.find((objv) => objv.o_id == update.o_id).published = 0;
                this.$message({
                    showClose: true,
                    message: 'Update has been withdrawn',
                    type: 'info'
                });
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if(err.response){
                    terr = err.response.data.errors;
                }
                this.$message({
                    showClose: true,
                    message: terr,
                    type: 'error'
                });
            });
        },
        publishUpdate(update){
            this.axios.put('/api/v1/updates/publish/'+update.o_id, {},
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                this.updates.find((objv) => objv.o_id == update.o_id).published = 1;
                this.$message({
                    showClose: true,
                    message: 'Update has been published',
                    type: 'info'
                });
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if(err.response){
                    terr = err.response.data.errors;
                }
                this.$message({
                    showClose: true,
                    message: terr,
                    type: 'error'
                });
            });
        },
        deleteUpdate(update) {
            this.axios.delete('/api/v1/updates/'+update.o_id,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                var temp = this.updates.find((objv) => objv.o_id == update.o_id);
                var index = this.updates.indexOf(temp);
                this.updates.splice(index, 1);
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if(err.response){
                    terr = err.response.data.errors;
                }
                this.$message({
                    showClose: true,
                    message: terr,
                    type: 'error'
                });
            });
        },
        changePage(newPage) {
            this.$set(this, 'pageLoading', true);
            this.page = newPage;
            this.getAdminUpdates();
        },
        getAdminUpdates() {
            this.pageLoading = true;
            if(this.selectedTerms != null){
                this.axios.get(this.buildTermPageURI('/api/v1/updates/admin', this.selectedTerms, this.page),
                    {
                        headers: {'Content-Type': 'application/json'},
                        credentials: 'same-origin'
                    }).then((response) => {
                    this.updates = response.data.data;
                    this.lastPage = response.data.last_page;
                    this.pageLoading = false;
                }).catch((err) => {
                    this.pageLoading = false;
                    console.error(err);
                    var terr = err;
                    if(err.response){
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: 'error'
                    });
                });
            }
        },
        showUpdate(val) {
            this.$router.push('/admin/updates/'+val.o_id);
        }
    }
}
</script>
